<template>
  <div class="page-container">
    <div class="query-title">销售计划单查询&修改</div>

    <div class="content">
      <QueryParams ref="QueryParams" :search-field="searchField" :loading="loading" @search="queryData" />
      <div class="table-container">
        <Table-filter
          title="明细"
          :rt-columns="rtColumns1"
          :lt-columns="ltColumns1"
          :grid-columns="gridOptions.columns"
          :count-data="countFileds"
          :all-options="allOptions"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
          @confirm="tableConfigConfirm"
        >
          <template #button>
            <table-button name="export" tip="导出" @click="exportExcel" />
            <table-button name="confirm" tip="审核通过" @click="auditBillOrder(1)" />
            <table-button name="cancle-apply" tip="审核不通过" @click="auditBillOrder(0)" />
          </template>
          <vxe-grid
            ref="xTable"
            v-loading="loading"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            height="300"
            max-height="500"
            align="center"
            size="mini"
            show-overflow
            :sort-config="{ multiple: true }"
            :empty-render="{name: 'NotData'}"
            :filter-config="{ remote: true }"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :edit-config="{ trigger: 'manual', mode: 'row' }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
            :row-class-name="rowClassName"
            @filter-change="filterChangeEvt"
          >
            <template #plan_order="{ row }">
              <span class="blue" @click="goOrderDetail(row)">{{ row.plan_order }}</span>
            </template>
          </vxe-grid>
        </Table-filter>
      </div>
    </div>

    <table-custom-filter ref="CustomFilter" :current-filter-field="currentFilterField" @confirm="customeFilter" />

  </div>
</template>

<script>
import { getSaleList, apiSaleResolve, apiSaleReject } from '@/api/sap/sale-plan'
import tableMixins from '@/utils/tableMixins'
import pageConfig from './config/salePlanOrderQuery'
import { frontExport, concurrencyReq } from '@/utils/frontExport'
import { mapGetters } from 'vuex'
export default {
  mixins: [tableMixins],
  data() {
    return {
      loading: false,
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', field: 'checkbox', width: 50 }
        ],
        data: []
      },
      searchField: {},
      isSetFilter: false
    }
  },
  computed: {
    ...mapGetters(['role'])
  },
  created() {
    this.initPage(pageConfig)
  },
  methods: {
    goOrderDetail(row) {
      if (row.order_type === 'ZP01') {
        this.$router.push({
          path: '/wly/sale-plan/sale-plan-check',
          query: {
            order: row.plan_order
          }
        })
      } else {
        if (row.adj_reason === 'S001' || row.adj_reason === 'S002') {
          this.$router.push({
            path: '/wly/sale-plan/theater',
            query: {
              order: row.plan_order
            }
          })
        } else {
          this.$router.push({
            path: '/wly/sale-plan/sale-plan-change-check',
            query: {
              order: row.plan_order
            }
          })
        }
      }
    },
    // 审核订单
    async auditBillOrder(type) {
      const data = this.$refs.xTable.getCheckboxRecords()
      if (!data.length) return this.$message.warning('请选择数据！')
      const params = {
        elements: data,
        user_bp: this.role.USER_BP
      }
      if (type) {
        const res = await apiSaleResolve(params)
        if (res.MSG_TYPE === 'S') {
          this.$message.success(res.MESSAGE)
          this.queryData()
        } else {
          this.$message.warning(res.MESSAGE)
        }
      } else {
        this.$prompt('请输入审核意见', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputType: 'texterea',
          inputPattern: /\S/,
          inputErrorMessage: '请输入意见'
        }).then(async({ value }) => {
          params.reject = value
          const res = await apiSaleReject(params)
          if (res.MSG_TYPE === 'S') {
            this.$message.success(res.MESSAGE)
            this.queryData()
          } else {
            this.$message.warning(res.MESSAGE)
          }
        })
      }
    },
    async queryData(page, ranges) {
      if (page === 1) {
        this.pagination.page = page
        // 保存 查询组件的查询参数
        if (ranges) {
          this.ranges = ranges
          this.handleRanges(ranges)
        }
      }
      const params = {
        mv_bp: this.$store.getters.role.USER_BP,
        role: this.$store.getters.role.ROLE,
        ...this.allConditions,
        ...this.pagination,
        is_result: 1,
        sort: this.sortData.concat(this.tableSort)
      }

      this.loading = true
      try {
        const { data, total, calculation, field } = await getSaleList(params)
        if (data.length === 0 && (total - 0)) {
          this.queryData(1, ranges)
          return
        }
        this.pagination.totalCount = total - 0
        this.calculation = this.filtercalculation(calculation)
        // 更新计算值
        this.updateCount()
        if (this.showHeader) {
          this.gridOptions.data = this.tableCountData.concat(data)
        } else {
          this.gridOptions.data = data.concat(this.tableCountData)
        }
        this.allOptions = this.filterAllOptions(field)
        this.setFilter()
      } catch (e) {
        //
      }
      this.loading = false
    },
    async exportExcel() {
      const params = {
        mv_bp: this.$store.getters.role.USER_BP,
        ...this.allConditions
      }
      const data = await concurrencyReq(this.pagination.totalCount, params, getSaleList)
      frontExport(this.gridOptions.columns, data, '销售计划单')
    },
    handleTablePaginationChange(pages) {
      Object.assign(this.pagination, pages)
      this.queryData()
    }
  }
}
</script>
<style lang="scss" scoped>
.blue {
  color: rgb(45, 146, 214);
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/sale-plan-manage/salePlanOrderQuery.vue